import { kpEndpoint, kpParams, thirdPartyUrls } from '@/axios'
import axios from 'axios'
import countryCodeData from '@/assets/data/countryCode.json'
import authRequest from '@/auth'

export const SET_FORM_DATA = 'SET_FORM_DATA'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'
export const GET_COUNTRY_CODE = 'GET_COUNTRY_CODE'
export const REGISTER_USER = 'REGISTER_USER'
export const REQUEST_OTP = 'REQUEST_OTP'
export const VERIFY_OTP = 'VERIFY_OTP'
export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export const SET_TERMS_ACCEPTED = 'SET_TERMS_ACCEPTED'
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE'
export const RESET_IMAGE = 'RESET_IMAGE'

const initialFormState = {
  firstName: '',
  lastName: '',
  country: null,
  email: '',
  password: '',
  phone: '',
  companyName: '',
  companyRole: '',
  userType: '',
  selectedLaunchDate: '',
  logoUrl: '',
  bannerUrl: '',
}

const state = {
  formData: { ...initialFormState },
  termsAccepted: false,
  local_logo: null,
  local_banner: null,
  allCountryCodes: countryCodeData.map(country => ({
    ...country,
    label: `${country.flag} ${country.dial_code}`,
  })),
}

const actions = {
  async [GET_COUNTRY_CODE]({ state }) {
    try {
      const response = await axios.get(thirdPartyUrls.ip2c)
      if (response) {
        const result = response.data
        const userCountryData = state.allCountryCodes.find(country => country.code === result.slice(2, 4))
        if (userCountryData && !state.formData.country) {
          state.formData.country = userCountryData
        }
      }
    } catch (err) {
      console.error(err)
    }
  },
  async [UPLOAD_IMAGE](ctx, payload) {
    const formData = new FormData()
    formData.append('file', payload.file)
    state[`local_${payload.type}`] = payload.file
    return authRequest({
      ...kpParams(kpEndpoint.files.newUserImageUpload, payload.fileType),
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      payload: formData,
      onUploadProgress: payload.onUploadProgress,
      cancelToken: payload.cancelToken,
    })
  },
  async [REGISTER_USER]({ state }) {
    const payload = {
      role: state.formData.userType,
      entityName: state.formData.companyName,
      firstName: state.formData.firstName,
      lastName: state.formData.lastName,
      country: state.formData.country.name,
      countryCode: state.formData.country.dial_code,
      companyRole: state.formData.companyRole,
      phone: state.formData.phone,
      email: state.formData.email,
      launchDate: state.formData.selectedLaunchDate,
      logoUrl: state.formData.logoUrl,
      bannerUrl: state.formData.bannerUrl,
      ...(state.formData.password && {
        password: state.formData.password,
        password2: state.formData.password,
      }),
    }

    return authRequest({ ...kpEndpoint.user.register, payload })
  },
  async [REQUEST_OTP](_, { email }) {
    const payload = { email }
    return authRequest({ ...kpEndpoint.user.requestOtp, payload })
  },
  async [VERIFY_OTP](_, { email, code }) {
    const payload = { email, otp: String(code) }
    return authRequest({ ...kpEndpoint.user.verifyOtp, payload })
  },
  async [VERIFY_EMAIL](_, { email }) {
    const payload = { email }
    return authRequest({ ...kpEndpoint.user.verifyEmail, payload })
  },
}

const mutations = {
  [SET_FORM_DATA](state, data) {
    state.formData = {
      ...state.formData,
      ...data,
    }
  },
  [RESET_FORM_DATA](state) {
    state.formData = { ...initialFormState }
  },
  [SET_TERMS_ACCEPTED](state, value) {
    state.termsAccepted = value
  },
  [RESET_IMAGE](state, type) {
    state[`local_${type}`] = null
    state.formData[`${type}Url`] = ''
  },
}

export default {
  state,
  mutations,
  actions,
}
